const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/m-packages",
    meta: {},
    name: "m-packages",
    component: () => import("@/modules/mpackages/RootView")
});

export default Routes;